import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Text, Tooltip } from '@mantine/core';
import { IconDiamond } from '@tabler/icons-react';
import { useAtom } from 'jotai';
import { diamondsAtom, rechargeOverlayOpenAtom } from '@/stores/atoms/walletAtoms';
const DiamondsIndicator = ({ compact = false }) => {
    const [diamonds] = useAtom(diamondsAtom);
    const [, setRechargeOpen] = useAtom(rechargeOverlayOpenAtom);
    const value = Number(diamonds ?? 0).toFixed(2);
    return (_jsx(Tooltip, { label: "\u4F59\u989D / \u53BB\u5145\u503C", children: _jsxs("div", { role: "button", "aria-label": "\u4F59\u989D", onClick: () => setRechargeOpen(true), style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                padding: compact ? '2px 8px' : '6px 10px',
                borderRadius: 9999,
                cursor: 'pointer',
                userSelect: 'none',
                WebkitTapHighlightColor: 'transparent',
                // Semi-transparent frosted glass background for readability
                background: 'rgba(0,0,0,0.25)',
                backdropFilter: 'blur(8px) saturate(120%)',
                WebkitBackdropFilter: 'blur(8px) saturate(120%)',
                border: '1px solid rgba(255,255,255,0.12)',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            }, children: [_jsx(IconDiamond, { size: compact ? 14 : 16, color: "#74c0fc" }), _jsx(Text, { size: compact ? 'xs' : 'sm', fw: 700, style: { color: 'var(--app-text-primary)' }, children: value })] }) }));
};
export default DiamondsIndicator;
